export class Base64 {
    constructor(value) {
        this.type = 'Base64';
        const base64ImagePattern = /^data:image\/[\w+]+;base64,/;
        if (!base64ImagePattern.test(value)) {
            throw new Error('Invalid Base64 initialize');
        }
        this._base64 = value;
    }
    get value() {
        return this._base64;
    }
    static hydrate(data) {
        return new Base64(data._base64);
    }
}
